import { useEffect } from "react";
import { router, type Href } from "expo-router";
import {
  addNotificationResponseListener,
  getLastNotificationUrl,
} from "../lib/push";

// The url comes from the push payload (data.url), so only navigate to
// in-app paths — never arbitrary strings.
function redirect(url: string) {
  if (!url.startsWith("/")) return;
  router.push(url as Href);
}

/**
 * Deep-links notification taps: navigates to `data.url` from the push
 * payload, covering both cold starts (tap launched the app) and taps while
 * the app is running.
 * https://docs.expo.dev/versions/latest/sdk/notifications/#handle-push-notifications-with-navigation
 */
export function useNotificationObserver() {
  useEffect(() => {
    const lastUrl = getLastNotificationUrl();
    if (lastUrl) redirect(lastUrl);

    return addNotificationResponseListener(redirect);
  }, []);
}
